import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';

import thunk from 'redux-thunk';
import rootReducer from '../reducers/index';

const middleware = [
  applyMiddleware(thunk)
];
const createStoreWithMiddleware = composeWithDevTools(...middleware)(createStore);

function createStoreWithMiddlewareAndHotReloading(rootReducer, initialState) {
  const store = createStoreWithMiddleware(rootReducer, initialState);
  module.hot.accept('../reducers', () => {
    /*
     * Note: you can't do:
     * `store.replaceReducer(rootReducer)`
     * here, contrary to the docs on
     * https://redux.js.org/recipes/configuring-your-store
     *
     * If you do, hot reloading won't actually work right.
     * Making changes to the reducers won't reload the page,
     * but those changes will not be respected.
     */

    store.replaceReducer(require('../reducers/index').default);
  });
  return store;
}

export default function initializeStore(initialState) {
  const createStoreFn = (module.hot)
    ? createStoreWithMiddlewareAndHotReloading
    : createStoreWithMiddleware;

  return createStoreFn(rootReducer, initialState);
}
